import { change, formValueSelector } from 'redux-form';
import { REDUX_FORM_ARRAY_REMOVE } from '@hbrisk/sp3-risk-model-support/actions/types.js';
import {
  COMPONENT_POPULATION,
  COMPONENT_POPULATION_PERFORMANCE_GROUPS as PERFORMANCE_GROUPS,
  PERFORMANCE_GROUP_RESPONSE_ITEM_KEY as RESPONSE_ITEM_KEY,
  STRUCTURAL_RESPONSES,
  STRUCTURAL_RESPONSE_DERIVED_FROM as DERIVED_FROM,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';

const updateDerivedFromOnDeletedResponse = ({ store, action, form, prevState }) => {
  const { type } = action;

  if (type === REDUX_FORM_ARRAY_REMOVE) {
    const {
      meta: { field, form: actionForm, index: deletingIndex },
    } = action;
    if (actionForm === form && field === STRUCTURAL_RESPONSES) {
      const { dispatch } = store;
      const state = store.getState();
      const {
        [STRUCTURAL_RESPONSES]: structuralResponses,
        [COMPONENT_POPULATION]: componentPopulation,
      } = formValueSelector(form)(state, STRUCTURAL_RESPONSES, COMPONENT_POPULATION);

      const prevStructuralResponses = formValueSelector(form)(prevState, STRUCTURAL_RESPONSES);
      const deletingItemKey = prevStructuralResponses[deletingIndex].itemKey;
      structuralResponses.forEach((response, index) => {
        if (response[DERIVED_FROM] === deletingItemKey) {
          dispatch(change(form, `${STRUCTURAL_RESPONSES}[${index}][${DERIVED_FROM}]`, null));
        }
      });

      componentPopulation.forEach((component, componentIndex) => {
        const { [PERFORMANCE_GROUPS]: performanceGroups } = component;
        performanceGroups.forEach((performanceGroup, pgIndex) => {
          const responseItemKeyField = `${COMPONENT_POPULATION}[${componentIndex}][${PERFORMANCE_GROUPS}][${pgIndex}][${RESPONSE_ITEM_KEY}]`;

          if (performanceGroup[RESPONSE_ITEM_KEY] === deletingItemKey) {
            dispatch(change(form, responseItemKeyField, null));
          }
        });
      });
    }
  }
};

export default updateDerivedFromOnDeletedResponse;
